module.exports = __webpack_public_path__ + "img/scan.e7f2c20b.png";